import { useState } from "react";
import CreatableSelect from 'react-select/creatable';
import moment from "moment";
import { applyTimeZone } from "../../utils/utils";
import { getHiddenRehearsalCategories, getStatsRehearsalCategoryOptions } from './statsEventCategories';
import "./StatsIndividualTab.css";

function StatsEventFilters({
    // Event type filters (required)
    filtersEvents,
    setFiltersEvents,
    events,
    eventCategories,

    // Min attendees (optional)
    minAttendees,
    setMinAttendees,

    // Keyword filters (optional)
    keywordFilters,
    setKeywordFilters,

    // Fitxat option (optional)
    countFitxat,
    setCountFitxat,
    showFitxatOption = false,

    // User type filters (canalla/music) - optional
    showUserTypeFilters = true,

    // User filtering callbacks (optional)
    setChosenUsers,
    castellersInfo,
}) {
    const [showFilters, setShowFilters] = useState(false);
    const hiddenCategories = getHiddenRehearsalCategories(filtersEvents);
    const categoryOptions = getStatsRehearsalCategoryOptions(eventCategories, events, filtersEvents);

    // Count active filters for summary
    const activeFilterCount = [
        filtersEvents?.activitats,
        filtersEvents?.comercials,
        filtersEvents?.reunions,
        filtersEvents?.canalla,
        filtersEvents?.music,
        filtersEvents?.actuacions,
        filtersEvents?.assaigs,
        minAttendees > 0,
    ].filter(Boolean).length + hiddenCategories.length;

    const hasKeywords = keywordFilters?.length > 0;
    const hasHiddenEvents = (filtersEvents?.ids?.length > 0) || (filtersEvents?.titles?.length > 0);

    return (
        <div className="stats-filters-container">
            <div className="stats-filters-header-row" onClick={() => setShowFilters(prev => !prev)}>
                <h2 className="stats-section-header">
                    <i className={`fas fa-chevron-${showFilters ? 'down' : 'right'}`}></i>
                    Filtres
                </h2>
                {!showFilters && (activeFilterCount > 0 || hasKeywords || hasHiddenEvents) ? (
                    <div className="stats-filters-summary">
                        {activeFilterCount > 0 ? (
                            <span className="stats-individual-chip">
                                {activeFilterCount} tipus amagat{activeFilterCount !== 1 ? 's' : ''}
                            </span>
                        ) : null}
                        {keywordFilters?.map(kw => (
                            <span key={`kw-${kw}`} className="stats-individual-chip">{kw}</span>
                        ))}
                        {hasHiddenEvents ? (
                            <span className="stats-individual-hidden-chip">
                                {(filtersEvents?.ids?.length || 0) + (filtersEvents?.titles?.length || 0)} esdeveniment{((filtersEvents?.ids?.length || 0) + (filtersEvents?.titles?.length || 0)) !== 1 ? 's' : ''} amagat{((filtersEvents?.ids?.length || 0) + (filtersEvents?.titles?.length || 0)) !== 1 ? 's' : ''}
                            </span>
                        ) : null}
                    </div>
                ) : null}
            </div>

            {showFilters ? (
                <div className="stats-filters-content">
                    {/* Event Type Filters */}
                    <div className="stats-individual-filter-group">
                        <label className="stats-individual-filter-label">Amagar tipus d'esdeveniment</label>
                        <div className="stats-event-type-filters">
                            <div className="stats-event-filter-row">
                                <label className="stats-individual-checkbox">
                                    <input
                                        type="checkbox"
                                        checked={filtersEvents?.assaigs || false}
                                        onChange={e => setFiltersEvents(prev => ({ ...prev, assaigs: e.target.checked }))}
                                    />
                                    No mostrar assaigs
                                </label>
                            </div>

                            <div className="stats-event-filter-row">
                                <label className="stats-individual-checkbox">
                                    <input
                                        type="checkbox"
                                        checked={filtersEvents?.actuacions || false}
                                        onChange={e => setFiltersEvents(prev => ({ ...prev, actuacions: e.target.checked }))}
                                    />
                                    No mostrar actuacions
                                </label>
                            </div>

                            <div className="stats-event-filter-row">
                                <label className="stats-individual-checkbox">
                                    <input
                                        type="checkbox"
                                        checked={filtersEvents?.activitats || false}
                                        onChange={e => setFiltersEvents(prev => ({ ...prev, activitats: e.target.checked }))}
                                    />
                                    No mostrar activitats
                                </label>
                            </div>

                            <div className="stats-event-filter-row">
                                <label className="stats-individual-checkbox">
                                    <input
                                        type="checkbox"
                                        checked={filtersEvents?.comercials || false}
                                        onChange={e => setFiltersEvents(prev => ({ ...prev, comercials: e.target.checked }))}
                                    />
                                    No mostrar comercials
                                </label>
                            </div>

                            <div className="stats-event-filter-row">
                                <label className="stats-individual-checkbox">
                                    <input
                                        type="checkbox"
                                        checked={filtersEvents?.reunions || false}
                                        onChange={e => setFiltersEvents(prev => ({ ...prev, reunions: e.target.checked }))}
                                    />
                                    No mostrar reunions
                                </label>
                            </div>

                            {showUserTypeFilters ? (
                                <div className="stats-event-filter-row">
                                    <label className="stats-individual-checkbox">
                                        <input
                                            type="checkbox"
                                            checked={filtersEvents?.canalla || false}
                                            onChange={e => {
                                                const newValue = e.target.checked;
                                                setFiltersEvents(prev => ({ ...prev, canalla: newValue }));
                                                if (newValue && setChosenUsers && castellersInfo) {
                                                    setChosenUsers(prevUsers => prevUsers.filter(user => castellersInfo[user]?.canalla !== 1));
                                                }
                                            }}
                                        />
                                        No mostris canalla
                                    </label>
                                </div>
                            ) : null}

                            {showUserTypeFilters ? (
                                <div className="stats-event-filter-row">
                                    <label className="stats-individual-checkbox">
                                        <input
                                            type="checkbox"
                                            checked={filtersEvents?.music || false}
                                            onChange={e => {
                                                const newValue = e.target.checked;
                                                setFiltersEvents(prev => ({ ...prev, music: newValue }));
                                                if (newValue && setChosenUsers && castellersInfo) {
                                                    setChosenUsers(prevUsers => prevUsers.filter(user => castellersInfo[user]?.music !== 1));
                                                }
                                            }}
                                        />
                                        No mostris músics
                                    </label>
                                </div>
                            ) : null}
                        </div>
                    </div>

                    <div className="stats-individual-filter-group">
                        <label className="stats-individual-filter-label">Amagar assaigs per categoria</label>
                        <div className="stats-event-type-filters">
                            {categoryOptions.map(category => (
                                <div className="stats-event-filter-row" key={category.value}>
                                    <label className="stats-individual-checkbox">
                                        <input
                                            type="checkbox"
                                            checked={hiddenCategories.includes(category.value)}
                                            onChange={e => {
                                                const checked = e.target.checked;
                                                setFiltersEvents(prev => {
                                                    const others = getHiddenRehearsalCategories(prev).filter(id => id !== category.value);
                                                    return {
                                                        ...prev,
                                                        hiddenRehearsalCategories: checked ? [...others, category.value] : others,
                                                    };
                                                });
                                            }}
                                        />
                                        No mostrar assaigs de la categoria «{category.label}»
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Min Attendees Slider */}
                    {setMinAttendees ? (
                        <div className="stats-individual-filter-group">
                            <div className="stats-min-attendees-row">
                                <label className="stats-individual-filter-label">
                                    No mostrar esdeveniments amb menys de {minAttendees} assistents
                                </label>
                                <input
                                    type="range"
                                    min="0"
                                    max="100"
                                    value={minAttendees || 0}
                                    onChange={e => setMinAttendees(parseInt(e.target.value) || 0)}
                                    className="stats-min-attendees-slider"
                                />
                            </div>
                        </div>
                    ) : null}

                    {/* Keyword Filters */}
                    {setKeywordFilters ? (
                        <div className="stats-individual-filter-group">
                            <label className="stats-individual-filter-label">Paraules clau</label>
                            <CreatableSelect
                                isMulti
                                className="basic-multi-select"
                                classNamePrefix="select"
                                placeholder="Només mostrar esdeveniments que continguin aquestes paraules clau (ex: comercial, taller, paradeta)..."
                                value={keywordFilters?.map(kw => ({ value: kw, label: kw })) || []}
                                onChange={selected => setKeywordFilters(selected ? selected.map(s => s.value) : [])}
                                formatCreateLabel={inputValue => `Afegir "${inputValue}"`}
                                noOptionsMessage={() => "Escriu una paraula clau i prem Enter"}
                            />
                        </div>
                    ) : null}

                    {/* Fitxat Option */}
                    {showFitxatOption && setCountFitxat ? (
                        <div className="stats-individual-filter-group">
                            <label className="stats-individual-checkbox">
                                <input
                                    type="checkbox"
                                    checked={countFitxat || false}
                                    onChange={e => setCountFitxat(e.target.checked)}
                                />
                                Mostra "Fitxat" en blau
                            </label>
                        </div>
                    ) : null}

                    {/* Hidden Events by ID */}
                    {filtersEvents?.ids?.length > 0 ? (
                        <div className="stats-individual-filter-group">
                            <label className="stats-individual-filter-label">Events puntuals amagats</label>
                            <div className="stats-individual-hidden-events">
                                {filtersEvents.ids.map(id => {
                                    const event = events?.find(e => parseInt(e.id) === parseInt(id));
                                    return (
                                        <div key={`id-${id}`} className="stats-individual-hidden-chip">
                                            <span>{event ? `${event.title} (${applyTimeZone(event['data-esperada-inici']).format('DD/MM/YYYY')})` : `Event ${id}`}</span>
                                            <button
                                                onClick={() => setFiltersEvents(prev => ({
                                                    ...prev,
                                                    ids: prev.ids.filter(i => i !== id)
                                                }))}
                                                className="stats-individual-remove-btn"
                                                title="Restaurar esdeveniment"
                                            >
                                                <i className="fas fa-times"></i>
                                            </button>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    ) : null}

                    {/* Hidden Events by Title */}
                    {filtersEvents?.titles?.length > 0 ? (
                        <div className="stats-individual-filter-group">
                            <label className="stats-individual-filter-label">Events recorrents amagats</label>
                            <div className="stats-individual-hidden-events">
                                {filtersEvents.titles.map(title => (
                                    <div key={`title-${title}`} className="stats-individual-hidden-chip">
                                        <span>Tots els "{title}"</span>
                                        <button
                                            onClick={() => setFiltersEvents(prev => ({
                                                ...prev,
                                                titles: prev.titles.filter(t => t !== title)
                                            }))}
                                            className="stats-individual-remove-btn"
                                            title="Restaurar esdeveniments"
                                        >
                                            <i className="fas fa-times"></i>
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : null}
                </div>
            ) : null}
        </div>
    );
}

export default StatsEventFilters;
